import { bagIcon } from '../icons';
import { checkCheckoutReady } from '../../../utils/merchantData';
import './index.scss';

export class ProductSetPickerFooter extends HTMLElement {
  constructor() {
    super();
    this.checkoutReady = checkCheckoutReady();
    this.onEventsBind = this.onEvents.bind(this);
    this.model = {};
    this.init();
  }
  connectedCallback() {
    this.bindEvents();
  }
  disconnectedCallback() {
    this.removeEventsListener();
  }
  bindEvents() {
    this.addEventListener('click', this.onEventsBind);
  }
  removeEventsListener() {
    this.removeEventListener('click', this.onEventsBind);
  }
  init() {
    this.classList.add('product-set-picker-footer');
  }
  onEvents(e) {
    if (e.target.closest('.js-add-to-cart')) {
      this.onAddToCart();
      return;
    }
    if (e.target.closest('.js-info')) {
      this.onShowSelectedInfo();
      return;
    }
  }
  onAddToCart() {
    const { loading, finishSelected } = this.model;
    if (!loading && this.checkoutReady && finishSelected) {
      document.querySelector('product-set-picker').onAddToCart();
      return;
    }
    if (!this.checkoutReady) {
      this.showMessageForm();
      document.querySelector('product-set-picker').onClose();
    }
  }
  showMessageForm() {
    angular.element('body').injector().get('$rootScope').showMessageForm();
  }
  onShowSelectedInfo() {
    const { product, currentSelectedNum } = this.model;
    if (!currentSelectedNum) {
      return;
    }
    if (this.closest(`sl-modal[sl-modal-id="${product._id}"]`)) {
      document.querySelector('product-set-picker')?.onShowSelectedInfo?.();
    }
  }
  updateModel(model) {
    this.model = model;
    this.render();
  }
  render() {
    this.renderBase();
    this.renderContainerStyle();
    this.renderButton();
    this.renderContent();
    this.renderError();
    this.renderProcess();
  }
  renderBase() {
    if (this.children.length > 0) {
      return;
    }
    const template = `
      <div class="product-set-picker-footer__content js-content">
        <div class="product-set-picker-footer__info js-info">
          <span class="icon">${bagIcon}</span>
          <span class="tip js-tip"></span>
          <span class="fa fa-angle-right arrow"></span>
        </div>
        <div class="product-set-picker-footer__error js-error"></div>
      </div>
      <button class="product-set-picker-footer__action-button js-add-to-cart">
        <span class="action-name">${window.shopline.i18next.t('Add To Cart', {
          ns: 'translation',
        })}</span>
        <span class="fa fa-spinner loading-icon"></span>
      </button>
      <div class="product-set-picker-footer__error js-error"></div>
      <div class="product-set-picker-footer__process js-process"></div>
    `;
    this.innerHTML = template;
  }
  renderContainerStyle() {
    if (!this.model.hasSufficientStock && this.checkoutReady) {
      this.classList.add('sold-out');
    }
  }
  renderContent() {
    const {
      currentSelectedNum,
      mustSelectNum,
      hasSufficientStock,
      hasVariationsChildProduct,
    } = this.model;

    if (!hasSufficientStock && this.checkoutReady) {
      this.querySelector('.js-content').remove();
      return;
    }

    if (!this.checkoutReady) {
      this.querySelector('.js-content').classList.add('checkout-not-ready');
      this.querySelector('.js-content').innerHTML = window.shopline.i18next.t(
        'Please message the shop owner for order details',
        {
          ns: 'translation',
        },
      );
      return;
    }

    if (hasVariationsChildProduct && currentSelectedNum > 0) {
      this.classList.add('has-selected-entry');
    } else {
      this.classList.remove('has-selected-entry');
    }

    this.querySelector('.js-tip').innerHTML = window.shopline.i18next.t(
      'n/total items selected',
      {
        ns: 'translation',
        n: currentSelectedNum,
        total: mustSelectNum,
      },
    );
  }
  renderButton() {
    const {
      hasSufficientStock,
      salesStarted,
      salesEnded,
      loading,
      finishSelected,
    } = this.model;
    const $button = this.querySelector('.js-add-to-cart');
    const $actionName = $button.querySelector('.action-name');
    $button.classList.remove('disabled');
    $button.classList.remove('loading');
    if (loading) {
      $button.classList.add('loading');
    }
    if (!finishSelected && this.checkoutReady) {
      $button.classList.add('disabled');
    }
    if (!this.checkoutReady) {
      $actionName.innerHTML = window.shopline.i18next.t('Contact', {
        ns: 'translation',
      });
      return;
    }
    if (!salesStarted) {
      $actionName.innerHTML = window.shopline.i18next.t('COMING SOON', {
        ns: 'translation',
      });
      return;
    }
    if (salesEnded) {
      $actionName.innerHTML = window.shopline.i18next.t('AVAILABLE TIME OVER', {
        ns: 'translation',
      });
      return;
    }
    if (!hasSufficientStock) {
      $actionName.innerHTML = window.shopline.i18next.t('Sold out', {
        ns: 'translation',
      });
      return;
    }
    $actionName.innerHTML = window.shopline.i18next.t('Add To Cart', {
      ns: 'translation',
    });
  }
  renderError() {
    const { error, finishSelected } = this.model;

    this.querySelectorAll('.js-error').forEach(($error) => {
      $error.innerHTML = finishSelected ? error || '' : '';
    });

    if (error) {
      this.classList.add('has-error');
    } else {
      this.classList.remove('has-error');
    }
  }
  renderProcess() {
    const {
      currentSelectedNum,
      mustSelectNum,
      allowAddToCart,
      hasVariationsChildProduct,
    } = this.model;
    let percentage =
      this.checkoutReady && allowAddToCart && hasVariationsChildProduct
        ? currentSelectedNum / mustSelectNum
        : 0;
    const $process = this.querySelector('.js-process');
    $process.style = `width: ${percentage * 100}%;`;
  }
}

if (!customElements.get('product-set-picker-footer')) {
  customElements.define('product-set-picker-footer', ProductSetPickerFooter);
}
